module.exports = "\n.alert-container {\n  position: fixed;\n  left: 40%;\n  top: 5%;\n  z-index: 99999;\n}\n\n\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/main/directives/alerts/alerts.directive.css
// module id = ./src/app/main/directives/alerts/alerts.directive.css
// module chunks = main